import React from 'react';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';

const QuizAlternative = ({ blok }) => {
  return (
    <div
      className="w-full col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-3 grid grid-cols-subgrid relative"
      {...storyblokEditable(blok)}
    >
      {blok.image?.map((img) => (
        <StoryblokComponent blok={img} />
      ))}
      <div className="absolute bottom-0 m-2 p-2 bg-white rounded">
        <span className="font-crystalCondensed">{blok.text}</span>
      </div>
    </div>
  );
};

export default QuizAlternative;
